import styled from 'styled-components';

const StyledNarrowInput = styled.div`
   width: 9em;
`;

StyledNarrowInput.displayName = 'StyledNarrowInput';

export { StyledNarrowInput };
